<div class="settings-card">
	<div class="settings-card__header">
		<img src="/assets/images/Group 24.svg" alt="" />
		<div class="settings-card__header-headline">
			<h2>Listă registre</h2>
		</div>
	</div>
</div>
<div class="requests-page">
	<div class="content-box">
		<div class="row">
			<div class="col-sm-12">
				<div class="section">
					<div class="section-top">
						<h3 class="section-title">Listă registre</h3>
						<div class="row">
							<div class="col">
								<button type="button" class="btn btn-sm btn-info pull-right ms-1" (click)="rerenderChildDT(registru_slug)">
									<i class="fa-solid fa-arrows-rotate"></i>
								</button>
								<button *ngIf="isAllowedToShowAddDialog()" type="button"
									class="btn btn-sm btn-primary pull-right ms-1" (click)="openAddDialog()">
									<i class="fa-solid fa-plus"></i>
									Adaugă
								</button>
								<button type="button"
									class="btn btn-sm btn-danger pull-right ms-1" (click)="exportRegister()">
									Exportă registru
								</button>
								<button type="button"
									class="btn btn-sm btn-warning pull-right ms-1" (click)="exportRegister(true)">
									Exportă registru(CSV)
								</button>
                                <button *ngIf="isAllowedToShowAddDialog()" type="button"
									class="btn btn-sm pull-right ms-1" (click)="toggleEditColumn()"
                                    [class]="{'btn-success': !isEditColumnVisible, 'btn-danger': isEditColumnVisible}">
									{{ isEditColumnVisible ? 'Anulează editarea' : 'Editare registru'  }}
								</button>
							</div>
						</div>
					</div>
                    <div class="d-flex justify-content-end p-2">
                        <button type="button" class="btn btn-light action-button" [popover]="popTemplate"
                            [adaptivePosition]="true" container="body" boundariesElement="viewport"
                            placement="left">
                            <img src="assets/icons/calendar-icon.svg" alt="Calendar" />
                            <span>{{ selectedStartDate | date : "dd.MM.yyyy" }} - {{ selectedEndDate | date :
                                "dd.MM.yyyy"
                                }}
                            </span>
                        </button>

                        <!-- Popover Template below-->
                        <ng-template #popTemplate>
                            <div class="popover">
                                <div class="row">
                                    <div class="col d-flex justify-content-between">
                                        <h2>Selectați intervalul</h2>
                                        <button style="height: 40px; width: 100px" class="btn btn-light close-btn"
                                            (click)="closePopover()">
                                            <img src="assets/icons/close.svg" alt="Închide"
                                                style="height: 20px; width: 20px" />
                                            <span class="close-text">ÎNCHIDE</span>
                                        </button>
                                    </div>
                                </div>
                                <div class="row mt-2 mb-2">
                                    <div class="col d-flex justify-content-between">
                                        <button type="button" class="action-button" [class.selected]="
                                            selectedFilteringButton === 'last_0_days'
                                            " (click)="setLastXDays(0)">
                                            <span>AZI</span>
                                        </button>
                                        <button type="button" class="action-button" [class.selected]="
                                            selectedFilteringButton === 'last_7_days'
                                            " (click)="setLastXDays(7)">
                                            <span>7 ZILE</span>
                                        </button>
                                        <button type="button" class="action-button" [class.selected]="
                                            selectedFilteringButton === 'last_30_days'
                                            " (click)="setLastXDays(30)">
                                            <span>30 ZILE</span>
                                        </button>
                                        <button type="button" class="action-button" [class.selected]="
                                            selectedFilteringButton === 'current_year'
                                            " (click)="setYear(0)">
                                            <span>AN CURENT</span>
                                        </button>
                                        <button type="button" class="action-button" [class.selected]="
                                            selectedFilteringButton === 'previous_year'
                                            " (click)="setYear(1)">
                                            <span>AN ANTERIOR</span>
                                        </button>
                                    </div>
                                </div>
                                <div class="datepicker-container">
                                    <div class="col">
                                        <div class="datepicker-header">
                                            <div class="text">DE LA:</div>
                                            <div class="date">
                                                {{ selectedStartDate | date : "mediumDate" }}
                                            </div>
                                        </div>
                                        <mat-card>
                                            <mat-calendar #startCalendar [startAt]="selectedStartDate"
                                                [(selected)]="selectedStartDate" [maxDate]="today"
                                                [maxDate]="selectedEndDate"
                                                (selectedChange)="rerenderChildDT(registru_slug)"></mat-calendar>
                                        </mat-card>
                                    </div>
                                    <div class="col">
                                        <div class="datepicker-header">
                                            <div class="text">PANA LA:</div>
                                            <div class="date">
                                                {{ selectedEndDate | date : "mediumDate" }}
                                            </div>
                                        </div>
                                        <mat-card>
                                            <mat-calendar #endCalendar [(selected)]="selectedEndDate"
                                                [maxDate]="today" (selectedChange)="rerenderChildDT(registru_slug)"></mat-calendar>
                                        </mat-card>
                                    </div>
                                </div>
                            </div>
                        </ng-template>
                    </div>
					<div class="card-filters">
						<div class="col d-flex justify-content-center">
							<mat-button-toggle-group name="fontStyle" aria-label="Font Style"
								(change)="onTableChange($event)" [value]="defaultParameter.slug">
                                <ng-container *ngFor="let option of registre$ | async">
                                    <mat-button-toggle *ngIf="option.active" [value]="option.slug">
                                        {{ option.name }}
                                    </mat-button-toggle>
                                </ng-container>
							</mat-button-toggle-group>
						</div>
					</div>

					<div *ngIf="isToateTabelVisible()">
						<app-toate-tabel-registru [registru_slug]="registru_slug" [registru_type]="registru_type" [selectedStartDate]="formatDate(selectedStartDate)" [selectedEndDate]="formatDate(selectedEndDate)" 
                            [isArchived]="isArchived"
                            (extractedDTparams)="importDTParams($event)">
                        </app-toate-tabel-registru>
					</div>
					<div *ngIf="registru_slug == 'certificate-urbanism'">
						<app-certificat-urbanism [isEditColumnVisible]="isEditColumnVisible" [registru_slug]="registru_slug" [registru_type]="registru_type" 
                            [selectedStartDate]="formatDate(selectedStartDate)" [selectedEndDate]="formatDate(selectedEndDate)" 
                            (extractedDTparams)="importDTParams($event)">
                        </app-certificat-urbanism>
					</div>
					<div *ngIf="registru_slug == 'autorizatii-construire'">
						<app-autorizatii-construire [isEditColumnVisible]="isEditColumnVisible" [registru_slug]="registru_slug" [registru_type]="registru_type" 
                            [selectedStartDate]="formatDate(selectedStartDate)" [selectedEndDate]="formatDate(selectedEndDate)"
                            (extractedDTparams)="importDTParams($event)">
                        </app-autorizatii-construire>
					</div>
					<div *ngIf="registru_slug == 'avize'">
						<app-avize [isEditColumnVisible]="isEditColumnVisible" [registru_slug]="registru_slug" [registru_type]="registru_type" 
                            [selectedStartDate]="formatDate(selectedStartDate)" [selectedEndDate]="formatDate(selectedEndDate)"
                            (extractedDTparams)="importDTParams($event)">
                        </app-avize>
					</div>
					<div *ngIf="registru_slug == 'aviz-principiu-studiu-publicitar'">
						<app-aviz-principiu-studiu-pub [isEditColumnVisible]="isEditColumnVisible" [registru_slug]="registru_slug" [registru_type]="registru_type" 
                            [selectedStartDate]="formatDate(selectedStartDate)" [selectedEndDate]="formatDate(selectedEndDate)"
                            (extractedDTparams)="importDTParams($event)">
                        </app-aviz-principiu-studiu-pub>
					</div>
					<div *ngIf="registru_slug == 'aviz-pud'">
						<app-aviz-pud [isEditColumnVisible]="isEditColumnVisible" [registru_slug]="registru_slug" [registru_type]="registru_type" 
                            [selectedStartDate]="formatDate(selectedStartDate)" [selectedEndDate]="formatDate(selectedEndDate)"
                            (extractedDTparams)="importDTParams($event)">
                        </app-aviz-pud>
					</div>
					<div *ngIf="registru_slug == 'aviz-supraetajare'">
						<app-aviz-supraetajare [isEditColumnVisible]="isEditColumnVisible" [registru_slug]="registru_slug" [registru_type]="registru_type" 
                            [selectedStartDate]="formatDate(selectedStartDate)" [selectedEndDate]="formatDate(selectedEndDate)"
                            (extractedDTparams)="importDTParams($event)">
                        </app-aviz-supraetajare>
					</div>
					<div *ngIf="registru_slug == 'acord_administrator_drum'">
						<app-acord-admin-drum [isEditColumnVisible]="isEditColumnVisible" [registru_slug]="registru_slug" [registru_type]="registru_type" 
                            [selectedStartDate]="formatDate(selectedStartDate)" [selectedEndDate]="formatDate(selectedEndDate)"
                            (extractedDTparams)="importDTParams($event)">
                        </app-acord-admin-drum>
					</div>
					<div *ngIf="registru_slug == 'autorizatie_construire_desfiintare'">
						<app-autorizatie-construire-desfiintare [isEditColumnVisible]="isEditColumnVisible" [registru_slug]="registru_slug" [registru_type]="registru_type" 
                            [selectedStartDate]="formatDate(selectedStartDate)" [selectedEndDate]="formatDate(selectedEndDate)"
                            (extractedDTparams)="importDTParams($event)">
                        </app-autorizatie-construire-desfiintare>
					</div>
					<div *ngIf="registru_slug == 'certificate_urbanism_informare'">
						<app-certificate-urbanism-informare [isEditColumnVisible]="isEditColumnVisible" [registru_slug]="registru_slug" [registru_type]="registru_type" 
                            [selectedStartDate]="formatDate(selectedStartDate)" [selectedEndDate]="formatDate(selectedEndDate)"
                            (extractedDTparams)="importDTParams($event)">
                        </app-certificate-urbanism-informare>
					</div>
					<div *ngIf="registru_slug == 'construire_desfiintare'">
						<app-construire-desfiintare [isEditColumnVisible]="isEditColumnVisible" [registru_slug]="registru_slug" [registru_type]="registru_type" 
                            [selectedStartDate]="formatDate(selectedStartDate)" [selectedEndDate]="formatDate(selectedEndDate)"
                            (extractedDTparams)="importDTParams($event)">
                        </app-construire-desfiintare>
					</div>
					<div *ngIf="registru_slug == 'construire_desfiintare_ingineresti'">
						<app-construire-desfiintare-ingineresti [isEditColumnVisible]="isEditColumnVisible" [registru_slug]="registru_slug" [registru_type]="registru_type" 
                            [selectedStartDate]="formatDate(selectedStartDate)" [selectedEndDate]="formatDate(selectedEndDate)"
                            (extractedDTparams)="importDTParams($event)">
                        </app-construire-desfiintare-ingineresti>
					</div>
					<div *ngIf="registru_slug == 'notificari'">
						<app-notificari [isEditColumnVisible]="isEditColumnVisible" [registru_slug]="registru_slug" [registru_type]="registru_type" 
                            [selectedStartDate]="formatDate(selectedStartDate)" [selectedEndDate]="formatDate(selectedEndDate)"
                            (extractedDTparams)="importDTParams($event)">
                        </app-notificari>
					</div>
					<div *ngIf="registru_slug == 'operatiuni_notariale'">
						<app-operatiuni-notariale [isEditColumnVisible]="isEditColumnVisible" [registru_slug]="registru_slug" [registru_type]="registru_type" 
                            [selectedStartDate]="formatDate(selectedStartDate)" [selectedEndDate]="formatDate(selectedEndDate)"
                            (extractedDTparams)="importDTParams($event)">
                        </app-operatiuni-notariale>
					</div>
					<div *ngIf="registru_slug == 'registru_avize_primar'">
						<app-avize-primar [isEditColumnVisible]="isEditColumnVisible" [registru_slug]="registru_slug" [registru_type]="registru_type" 
                            [selectedStartDate]="formatDate(selectedStartDate)" [selectedEndDate]="formatDate(selectedEndDate)"
                            (extractedDTparams)="importDTParams($event)">
                        </app-avize-primar>
					</div>

					<div class="section-spinner position-absolute" *ngIf="isLoading">
						<div class="spinner position-absolute top-50 start-50 translate-middle">
							<mat-spinner></mat-spinner>
							<h3 class="mt-2">
								{{ helper.dialogConfig.generalMessages.pleaseWait }}
							</h3>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>